<template>
  <div>
      <!-- ##### Hero Area Start ##### -->
        <div class="hero-slides">

          <carousel :items="1" :autoplay="true" :autoplayTimeout="8000"  @changed="changed" @updated="updated" ref="carousel" >                                                               
            <!-- fundamentos cristianos -->
            <div class="single-hero-slide bg-img img bg-overlay" :style="'background-image: url(' + require('@/assets/slider/foundation.jpg') +');'">
                <div class="container h-100">
                    <div class="row h-100 align-items-center">
                        <div class="col-12 col-lg-7">                            
                            <div class="hero-slides-content">
                                <h2 data-animation="fadeInUp" data-delay="500ms">Fundamentos Cristianos </h2>
                                <p data-animation="fadeInUp" data-delay="700ms"> En la Nueva Vida en Cristo es de suma importancia comprender los rudimentos de la Sana Doctrina. Por lo cual queremos compartir con usted una serie de enseñanzas para su edificación. </p>                                
                                <div class="donate-btn " data-animation="fadeInUp" data-delay="900ms">
                                    <router-link class="btn faith-btn m-1" :to="'/foundation'">Ver más</router-link>                        
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>   
            
            <!-- slider sermones -->
            <div class="single-hero-slide bg-img bg-overlay" :style="'background-image: url(' + require('@/assets/slider/2b.jpg') +');'">
                <div class="container h-100">
                    <div class="row h-100 align-items-center">
                        <div class="col-12 col-lg-7">                            
                            <div class="hero-slides-content">
                                <h2 data-animation="fadeInUp" data-delay="500ms">Servicios Anteriores </h2>
                                <p data-animation="fadeInUp" data-delay="700ms"> Nuestro deseo es poder responder al Señor, atender a su instrucción de mirar atentamente a los caminos de nuestros antepasados y preguntar en la historia cristiana, cuál es el Camino de Dios y seguirlo. </p>                                
                                <div class="donate-btn " data-animation="fadeInUp" data-delay="900ms">
                                    <router-link class="btn faith-btn m-1" :to="'/sermons'">Ver más</router-link>                        
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>   

             <!-- slider radio -->
            <div class="single-hero-slide bg-img " :style="'background-image: url(' + require('@/assets/slider/radio3.jpg') +');'">
                <div class="container h-100">
                    <div class="row h-100 align-items-center ">
                        <div class="col-12 col-lg-7">
                            <!-- Slides Content -->
                            <div class="hero-slides-content">                                
                                <h3 data-animation="fadeInUp" data-delay="300ms">Radio</h3>
                                <h2 data-animation="fadeInUp" data-delay="500ms">La Senda Antigua</h2>
                                <p data-animation="fadeInUp" data-delay="700ms">Escucha Radio La Senda Antigua, <br> con música inspiradora las 24 hrs del día.</p>
                                <div class="donate-btn " data-animation="fadeInUp" data-delay="900ms">
                                    <router-link class="btn faith-btn m-1" :to="'/radio'">sintonizar</router-link>                        
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>   
            
            <!-- slider homeschool -->
            <div class="single-hero-slide bg-img " :style="'background-image: url(' + require('@/assets/slider/4.jpg') +');'">
                <div class="container h-100">
                    <div class="row h-100 align-items-center">
                        <div class="col-12 col-lg-7">
                            <!-- Slides Content -->
                            <div class="hero-slides-content">
                                <!-- <h6 class="date" data-animation="fadeInUp" data-delay="100ms">July 2018</h6> -->                                
                                <h2 data-animation="fadeInUp" data-delay="500ms">Educación en Casa</h2>
                                <p data-animation="fadeInUp" data-delay="700ms">“Y todos tus hijos serán enseñados por Jehová; y se multiplicará la paz de tus hijos.” <br> Isa. 54:13.</p>
                                <div class="donate-btn " data-animation="fadeInUp" data-delay="900ms">
                                    <router-link class="btn faith-btn m-1" :to="'/homeschool'">saber más</router-link>                        
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>          

            <!-- slider santa cena -->
           <div class="single-hero-slide bg-img " :style="'background-image: url(' + require('@/assets/slider/communion.jpg') +');'">
                <div class="container h-100">
                    <div class="row h-100 align-items-center ">
                        <div class="col-12 col-lg-7">
                            <div class="hero-slides-content">                                                                
                                <h2 data-animation="fadeInUp" data-delay="500ms">Este es mi Cuerpo</h2>
                                <p data-animation="fadeInUp" data-delay="700ms">
                                  ...y habiendo dado gracias, lo partió y dijo: Tomad, comed; <br> esto es mi cuerpo que por vosotros es partido; haced esto en memoria de mí.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>    
          </carousel>    
        </div>

        <!-- ##### CTA Area Start ##### -->
        <div class="faith-cta-area" style="margin-top:-10px">
            <div class="container">
                <div class="row">
                    <div class="col-md-10">
                        <div class="cta-text d-flex justify-content-between align-items-center">
                            <h5 style="font-size:1rem">
                                Así dijo Jehová: Paraos en los caminos, y mirad, y preguntad por las sendas antiguas, cuál sea el buen camino, y andad por él, y hallaréis descanso para vuestra alma. Mas dijeron: No andaremos. 
                                <br> <small><i>Jeremías 6:16 RV1960</i></small>
                            </h5>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <router-link to="/sermons" class="btn faith-btn">Sermones</router-link>
                    </div>
                </div>
            </div>
        </div>
        <!-- ##### CTA Area End ##### -->


    
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";

export default {
  components: { carousel },
  mounted() {
    let prev = document.getElementsByClassName("owl-next")[0];
    prev.textContent = ">";
    let next = document.getElementsByClassName("owl-prev")[0];
    next.textContent = "<";

    setTimeout(() => {
      this.showBtn = true;
    }, 800);

    // setTimeout(() => {
    //   this.showBtn = false;
    //   prev.click();
    // }, 5000);
  },
  data() {
    return {
      showBtn: false,
    };
  },
  methods: {
    changed({ item }) {
      this.showBtn = false;
      if (item.index <= 1) {
        setTimeout(() => {
          this.showBtn = true;
        }, 1000);
      }
    },

    updated() {
      console.log("updated.-..");
    },
  },
};
</script>

<style >
.hero-slides-content {
  text-shadow: 0px 0px 16px #000 !important;
}

.hero-slides-content p {
  text-shadow: 0px 0px 16px #000 !important;
}

.scale-in-center {
  -webkit-animation: slide-in-top 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  animation: slide-in-top 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@-webkit-keyframes slide-in-top {
  0% {
    -webkit-transform: translateY(-1000px);
    transform: translateY(-1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes slide-in-top {
  0% {
    -webkit-transform: translateY(-1000px);
    transform: translateY(-1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}
</style>